const service = {
	DEPOSIT_SERVICE_DEPOSIT: 'deposit',
	DEPOSIT_SERVICE_LOAN: 'loan',
	DEPOSIT_SERVICE_WITHDRAWAL: 'withdraw',
}

const status = {
	DEPOSIT_SERVICE_STATUS_PENDING: 'pending',
	DEPOSIT_SERVICE_STATUS_ACCEPTED: 'accepted',
	DEPOSIT_SERVICE_STATUS_CANCELLED: 'cancelled',
	DEPOSIT_SERVICE_STATUS_REJECTED: 'rejected',
}

export function serviceColors() {
	const colors = {}
	colors[service.DEPOSIT_SERVICE_DEPOSIT] = '#237804'
	colors[service.DEPOSIT_SERVICE_LOAN] = '#faad14'
	colors[service.DEPOSIT_SERVICE_WITHDRAWAL] = '#a8071a'

	return colors
}

export function statusColors() {
	const colors = {}
	colors[status.DEPOSIT_SERVICE_STATUS_PENDING] = '#faad14'
	colors[status.DEPOSIT_SERVICE_STATUS_ACCEPTED] = '#87d068'
	colors[status.DEPOSIT_SERVICE_STATUS_CANCELLED] = '#fa541c'
	colors[status.DEPOSIT_SERVICE_STATUS_REJECTED] = '#b1093e'
	return colors
}

export {
	status,
	service
}
